import type { Call } from '@entities/call';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import { Logger } from '@main/utils/logger';
import type { BlindTransferNumberEventPublisher } from './blind-transfer-call.usecase';

export class BlindTransferNumberPublisher
  implements BlindTransferNumberEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish({ from, to }: Call): Promise<void> {
    const busIframe = await BusIframe.getIframe();
    const busEvent: BusEvent = {
      type: 'DIALER.START_COLD_TRANSFER',
      payload: {
        to: to,
        searchByTeam: to.startsWith('team:'),
      },
    };
    this.logger.info('Publisher: Blind transfer number', {
      action: 'transferNumber',
      to,
      from,
    });

    return BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: busEvent,
    });
  }
}
